import { createApp } from 'vue'
import App from './App.vue'
import myRouter from "@/scripts/router.js";
import globalVuexStore from "@/scripts/globalVuexStore";
import {yiguI18n} from '@/lang/i18nIndex';
import Vue3TouchEvents from "vue3-touch-events";

const app = createApp(App)
app.use(myRouter).use(globalVuexStore).use(yiguI18n).use(Vue3TouchEvents)
app.mount('#app')